import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAlert, updateFloatPanel } from "../../reducers/userConfigSlice";
import { FloatPanel } from "../../components/floatPanel";
import { ClientDetails, Datatable, OrderInfo, StateLabel, parseDate, translateMessage } from "@delibrandev/utils";

import "./style.css";
import { IoMdClose } from "react-icons/io";
import { CustomBlock } from "../../components/customBlock";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";
import { getOrderDetails, getOrders, printInvoice, printTicket } from "../../api/kd";
import { orderIdentifier } from "../../helpers/orderIdentifier";
import { orderTotal } from "../../helpers/orderAmounts";
import { OrderAmounts, OrderAmountProducts } from "./orderAmounts";

export const ListDisplay = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);

  const visible = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.visible);
  const queryId = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.queryId);
  const isEmpty = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.isEmpty);
  const orderId = queryId;

  const query = async () => {
    const response = await getOrders();
    if (response && !response.error) {
      setData(response.data);
      setOrders(addIdKeyIfMissing(response.data.orders?.slice().reverse() || []));
    }
  };

  useEffect(() => {
    query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const queryOrderId = async () => {
    const response = await getOrderDetails(orderId);
    if (response && !response.error) {
      setData(response.data);
    }
  };

  const printTicketQuery = async () => {
    try {
      const payload = {
        orderId: data.orderId,
      };
      const response = await printTicket(payload);
      if (response && !response.error) {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  const printInvoiceQuery = async () => {
    try {
      const payload = {
        orderId: data.orderId,
        isCorrective: false,
        paymentMethods: data.paymentMethod,
      };
      const response = await printInvoice(payload);
      if (response && !response.error) {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  useEffect(() => {
    if (queryId != null) queryOrderId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const sections = [{ text: null, callback: () => null, actions: ["search"], actionsWithSelect: [] }];
  const customHeaders = {
    number: "Nº de pedido",
    createdAt: "Fecha",
    email: "Cliente",
    SalesChannel: "Canal de venta",
    paymentStatus: "Estado del pago",
    total: "Total",
    status: "Estado del pedido",
  };
  const customData = {
    SalesChannel: (data) => data.identifier,
    createdAt: (date) => parseDate(date),
    number: (_data, row) => <div className="datatableCellCentered">{orderIdentifier(row)}</div>,
    paymentStatus: (data) => (
      <div className="datatableCellCentered">
        <StateLabel state={data} />
      </div>
    ),
    total: (_data, row) => (
      <div className="datatableCellCentered">
        {orderTotal(row)}
      </div>
    ),
    status: (data) => (
      <div className="datatableCellCentered">
        <StateLabel state={data} />
      </div>
    ),
  };


  const tabsContent = [
    {
      content: (
        <>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <CustomBlock
                name={""}
                content={
                  data && (
                    <>
                      <OrderInfo data={data} />
                      <OrderAmountProducts data={data} />
                    </>
                  )
                }
              />
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <CustomBlock
                    name={""}
                    content={
                      data && (
                        <OrderAmounts
                          data={data}
                          printTicket={printTicketQuery}
                          printInvoice={printInvoiceQuery}
                        />
                      )
                    }
                    description={""}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <CustomBlock name={""} content={data && <ClientDetails data={data} />} description={""} />
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  const CustomDesign = () => {
    const closeFloatPanel = () => {
      dispatch(updateFloatPanel({ visible: false, queryId: null, isEmpty: true }));
    };
    return (
      <>
        <div className="floatPanelHeader">
          <div className="floatPanelHeaderLeft">
            <button
              type="button"
              className="floatPanelCloseButton"
              onClick={() => closeFloatPanel(false)}
              aria-label="Cerrar panel"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  closeFloatPanel(false);
                }
              }}
            >
              <IoMdClose />
            </button>
            <div className="floatPanelHeaderTitle">{!isEmpty ? "Detalles del pedido" : "Crear atributo"}</div>
          </div>
          <div className="floatPanelHeaderRight"></div>
        </div>

        <div className="floatPanelBody">{tabsContent[0].content} </div>
      </>
    );
  };

  const handleFloatPanel = (orderData = null, isNew = false) => {
    if (!isNew && orderData) {
      dispatch(updateFloatPanel({ visible: true, queryId: orderData.orderId, isEmpty: false }));
    } else {
      dispatch(updateFloatPanel({ visible: false, queryId: null, isEmpty: true }));
    }
  };

  return (
    <div className="orders-display">
      <h4 className="p-2">Histórico de pedidos</h4>
      <div className="adminPanel listDisplayPanel">
        <Datatable
            data={orders}
            customHeaders={customHeaders}
            customData={customData}
            sections={sections}
            rowCallback={handleFloatPanel}
          />
        {visible && <FloatPanel template={<CustomDesign />} />}
      </div>
    </div>
  );
};
